import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_USER } from '../user/useUserQuery';

// Klaus-Kopplung im Mandanten-Tab (Addendum v1.2): verknüpfbare Klaus-Orgs
// laden, Mandant verknüpfen, Verknüpfung aufheben.

const KLAUS_SYNC_ENABLED = gql`
  query KlausSyncEnabled {
    klausSyncEnabled
  }
`;

/**
 * Ob die Klaus-Kopplung eingerichtet ist. Solange das nicht feststeht (oder
 * die Abfrage scheitert), gilt sie als aus: lieber nichts zeigen als einen
 * Klaus-Bereich ohne Klaus dahinter.
 */
export function useKlausSync(): { enabled: boolean; loading: boolean } {
  const { data, loading } = useQuery<{ klausSyncEnabled: boolean }>(KLAUS_SYNC_ENABLED, { fetchPolicy: 'cache-first' });
  return { enabled: data?.klausSyncEnabled === true, loading };
}

export function useKlausSyncEnabled(): boolean {
  return useKlausSync().enabled;
}

const KLAUS_LINKABLE_ORGS = gql`
  query KlausLinkableOrgs {
    klausLinkableOrgs {
      id
      name
    }
  }
`;

const LINK_COMPANY_TO_KLAUS = gql`
  mutation LinkCompanyToKlaus($companyId: String!, $klausOrgId: String!) {
    linkCompanyToKlaus(companyId: $companyId, klausOrgId: $klausOrgId)
  }
`;

const UNLINK_COMPANY_FROM_KLAUS = gql`
  mutation UnlinkCompanyFromKlaus($companyId: String!) {
    unlinkCompanyFromKlaus(companyId: $companyId)
  }
`;

export interface KlausOrgOption {
  id: string;
  name: string;
}

export function useKlausLinkableOrgsQuery() {
  return useLazyQuery<{ klausLinkableOrgs: KlausOrgOption[] }>(KLAUS_LINKABLE_ORGS, { fetchPolicy: 'network-only' });
}

export function useLinkCompanyToKlausMutation() {
  return useMutation<{ linkCompanyToKlaus: boolean }, { companyId: string; klausOrgId: string }>(
    LINK_COMPANY_TO_KLAUS,
    {
      refetchQueries: [{ query: GET_USER }],
      awaitRefetchQueries: true,
    }
  );
}

export function useUnlinkCompanyFromKlausMutation() {
  return useMutation<{ unlinkCompanyFromKlaus: boolean }, { companyId: string }>(UNLINK_COMPANY_FROM_KLAUS, {
    refetchQueries: [{ query: GET_USER }],
    awaitRefetchQueries: true,
  });
}
